
export enum AppointmentStatus {
  Active = "active",
  Canceled = "canceled",
}
